// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DollarCircleTwoToneSvg from "@fishx/icons-svg/es/asn/DollarCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var DollarCircleTwoTone = function DollarCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DollarCircleTwoToneSvg
  }));
};

DollarCircleTwoTone.displayName = 'DollarCircleTwoTone';
export default React.forwardRef(DollarCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DollarCircleTwoTone.js
// module id = 2437
// module chunks = 0